import { render } from "./DropdownElement.vue?vue&type=template&id=0a8823dc&scoped=true"
import script from "./DropdownElement.vue?vue&type=script&lang=js"
export * from "./DropdownElement.vue?vue&type=script&lang=js"

import "./DropdownElement.vue?vue&type=style&index=0&id=0a8823dc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a8823dc"]])

export default __exports__